(function () {
  'use strict';

  /* ── Config ──────────────────────────────────────────────────────
     Read once from sections/gw-con-data.liquid's JSON blob. Dates are
     plain YYYY-MM-DD text (no native date-picker setting type in
     Shopify schemas) — everything below works in whole calendar days,
     anchored to the Europe/London calendar date, so it never drifts
     with the visitor's own timezone or daylight saving. */
  var config = null;
  function readConfig() {
    if (config) return config;
    var el = document.getElementById('gw-con-list-config');
    if (!el) { config = { instockCutoffDays: 3, madeToOrderBufferDays: 3, cons: [] }; return config; }
    try { config = JSON.parse(el.textContent); } catch (e) { config = { instockCutoffDays: 3, madeToOrderBufferDays: 3, cons: [] }; }
    if (!config.cons) config.cons = [];
    return config;
  }

  /* ── Made-to-order detection ───────────────────────────────────────
     The theme has no "made-to-order" tag — every made-to-order product
     template (templates/product.*.json) carries an identical "Made To
     Order" accordion block listing lead times for SEVERAL categories at
     once (it's generic policy copy, not product-specific), while the
     plain default template (templates/product.json) carries no such
     block at all. So template_suffix is the real signal: non-blank
     suffix = made-to-order; which bullet applies is inferred from the
     suffix itself. MAX of each bullet's range, in working days:
       Mini Backpacks/Bucket Bags/Purses — 14–21  -> bifold-wallet, festival-backpacks(-artists)
       Shoes/boots/footwear — 21–28                -> (no template currently uses this bucket)
       Clothing incl. hoodies/t-shirts — 7–10       -> hoodies, clothing
       All-over-print clothing — 20–28              -> aop-hoodies
       Leggings — 14–21                             -> leggings
       Skate Decks — 14–21 (listed separately, same max as the backpack bucket) -> skatedecks
     Templates that ALSO carry the generic block but aren't covered by
     any bullet above (blanket, cj-birch-blanket, lunch-box-2, lunch-
     box-artists, spn-journal, perfect-product-page) are deliberately
     left OUT of this table rather than guessed — see initProductBox(),
     which hides the con box rather than show a made-up date for them. */
  var MTO_MAX_WORKING_DAYS = {
    'hoodies': 10,
    'clothing': 10,
    'aop-hoodies': 28,
    'leggings': 21,
    'bifold-wallet': 21,
    'festival-backpacks': 21,
    'festival-backpack-artists': 21,
    'skatedecks': 21
  };

  /* ── Calendar-day arithmetic (no Date-object timezone math) ────── */
  function parseISO(s) {
    if (!s) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s).trim());
    if (!m) return null;
    return { y: +m[1], m: +m[2], d: +m[3] };
  }
  function toEpochDays(p) { return Math.floor(Date.UTC(p.y, p.m - 1, p.d) / 86400000); }
  function fromEpochDays(n) {
    var d = new Date(n * 86400000);
    return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate() };
  }
  function addDays(p, n) { return fromEpochDays(toEpochDays(p) + n); }
  function dowOf(p) { return new Date(toEpochDays(p) * 86400000).getUTCDay(); } // 0=Sun..6=Sat
  function subtractWorkingDays(p, n) {
    var days = toEpochDays(p);
    var remaining = n;
    while (remaining > 0) {
      days -= 1;
      var dow = new Date(days * 86400000).getUTCDay();
      if (dow !== 0 && dow !== 6) remaining--;
    }
    return fromEpochDays(days);
  }
  function todayLondon() {
    var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' });
    var y, m, d;
    fmt.formatToParts(new Date()).forEach(function (part) {
      if (part.type === 'year') y = +part.value;
      if (part.type === 'month') m = +part.value;
      if (part.type === 'day') d = +part.value;
    });
    return { y: y, m: m, d: d };
  }

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function formatDate(p) { return p.d + ' ' + MONTHS[p.m - 1]; }
  function formatRange(start, end) {
    if (start.y === end.y && start.m === end.m) return start.d + '–' + end.d + ' ' + MONTHS[start.m - 1];
    return formatDate(start) + '–' + formatDate(end);
  }
  // "Comic Con Scotland (Edinburgh)" -> "Edinburgh"; falls back to the
  // full name when there's no parenthetical city.
  function shortName(con) {
    var m = /\(([^)]+)\)/.exec(con.name || '');
    return m ? m[1] : (con.name || '');
  }

  function leadDaysFor(templateSuffix) {
    if (!templateSuffix) return { known: true, isMTO: false, days: readConfig().instockCutoffDays };
    if (Object.prototype.hasOwnProperty.call(MTO_MAX_WORKING_DAYS, templateSuffix)) {
      return { known: true, isMTO: true, days: MTO_MAX_WORKING_DAYS[templateSuffix] + readConfig().madeToOrderBufferDays };
    }
    return { known: false, isMTO: false, days: 0 };
  }

  function latestOrderDateFor(con, lead) {
    var start = parseISO(con.start);
    if (!start) return null;
    return lead.isMTO ? subtractWorkingDays(start, lead.days) : addDays(start, -lead.days);
  }

  // Cons sorted by start date, excluding any with unparsable dates.
  function sortedValidCons() {
    return readConfig().cons.filter(function (c) { return parseISO(c.start) && parseISO(c.end); })
      .sort(function (a, b) { return toEpochDays(parseISO(a.start)) - toEpochDays(parseISO(b.start)); });
  }

  // Walks the con list in date order; skips any con already ended, and
  // any con whose order-by date has already passed (collecting them as
  // "skipped" so the caller can say "Too late for X — ..." using the
  // LAST skipped one, i.e. the nearest con that was just missed).
  function findNextAchievable(lead) {
    var today = todayLondon();
    var todayEpoch = toEpochDays(today);
    var cons = sortedValidCons();
    var skipped = [];
    for (var i = 0; i < cons.length; i++) {
      var con = cons[i];
      var endEpoch = toEpochDays(parseISO(con.end));
      if (endEpoch < todayEpoch) continue;
      var latest = latestOrderDateFor(con, lead);
      if (!latest) continue;
      if (todayEpoch <= toEpochDays(latest)) {
        return { con: con, latestOrderDate: latest, missedCon: skipped.length ? skipped[skipped.length - 1] : null };
      }
      skipped.push(con);
    }
    return null;
  }

  // Nearest con that hasn't ended yet, with no lead-time check at all —
  // used for the cart drawer's generic "going to [con]?" note, which
  // isn't about any specific product's dispatch time.
  function getNextUpcomingCon() {
    var today = todayLondon();
    var todayEpoch = toEpochDays(today);
    var cons = sortedValidCons();
    for (var i = 0; i < cons.length; i++) {
      if (toEpochDays(parseISO(cons[i].end)) >= todayEpoch) return cons[i];
    }
    return null;
  }

  function messageFor(result) {
    var dateText = formatDate(result.latestOrderDate);
    if (result.missedCon) {
      return 'Too late for ' + shortName(result.missedCon) + ' — order by ' + dateText + ' to collect at ' + result.con.name + '.';
    }
    return 'Skip the queue — order by ' + dateText + ' and collect from our stand at ' + result.con.name + ', ' + formatRange(parseISO(result.con.start), parseISO(result.con.end)) + '.';
  }

  function initProductBox() {
    var box = document.querySelector('[data-gw-con-box]');
    if (!box) return;
    var textEl = box.querySelector('[data-gw-con-box-text]');
    var lead = leadDaysFor(box.getAttribute('data-template-suffix') || '');
    if (!lead.known) { box.hidden = true; return; }
    var result = findNextAchievable(lead);
    if (!result) { box.hidden = true; return; }
    if (textEl) textEl.textContent = messageFor(result);
    box.hidden = false;
  }

  // "Collect at cons" trust-row item — same signal as the cart note
  // (any con that hasn't ended yet), not per-product achievability,
  // since the trust row is generic site messaging, not this specific
  // product's own dispatch math.
  function initTrustRow() {
    var item = document.querySelector('[data-gw-trust-con]');
    if (!item) return;
    item.hidden = !getNextUpcomingCon();
  }

  function initCartNote() {
    var note = document.getElementById('gw-drawer-con-note');
    if (!note) return;
    var con = getNextUpcomingCon();
    if (!con) { note.hidden = true; return; }
    note.textContent = 'Going to ' + shortName(con) + '? Choose collection at checkout and pick it up from our stand.';
    note.hidden = false;
  }

  function init() {
    readConfig();
    initProductBox();
    initTrustRow();
    initCartNote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.gwConFinder = {
    formatDate: formatDate,
    formatRange: formatRange,
    shortName: shortName,
    findNextAchievable: findNextAchievable,
    getNextUpcomingCon: getNextUpcomingCon,
    leadDaysFor: leadDaysFor,
    initProductBox: initProductBox,
    initTrustRow: initTrustRow,
    initCartNote: initCartNote
  };
})();
